// extracted by mini-css-extract-plugin
export default {"superlight-icon":"_superlight-icon_TQ6yCn","attachments":"_attachments_+ihvkF"};